import aT from '../const/action-type'
import initial from '../store/initial'
//
export default (state = initial.success, action) => {
  switch (action.type) {
    case aT.ADD_SUCCESS:
      return [...state, action.data]
    case aT.RESET_STORE:
      return initial.success
    case aT.SWITCH_WORKSPACE:
      return initial.success
    default:
      return state
  }
}
